


























import { Vue, Component, Emit } from 'vue-property-decorator'
import { FormRule } from '@/types/formRules.d.ts'
import { vaildW } from '@/utils/vaild'
import { cusElForm } from '@/types/form'
@Component
export default class Step1 extends Vue {
  form: any = {
    name: '',
    objectId: '',
    objectName: '',
    code: '',
    description: '',
  };
  created() {
    const { id, name } = this.$route.query
    if (id && name) {
      this.form.objectId = id
      this.form.objectName = name
    }
  }
  // nextStatus = false // 下一步状态/
  validatePass = (rule: any, value: any, cb: any) => {
    if (!vaildW.test(value)) {
      cb(new Error('校验不通过，编码仅支持大小写字母，下划线，请检查您的编码'))
      return
    }
    cb()
  };
  rules: any = {
    code: { required: true, validator: this.validatePass, trigger: 'blur' },
    name: { required: true, message: '请输入分群名称', trigger: 'blur' },
    description: { required: true, message: '请输入分群说明', trigger: 'blur' }
  };

  vaildSubmit(cb: Function) {
    (this.$refs.form as cusElForm).validate((valid: boolean) => {
      if (valid) {
        cb(valid, this.form)
      } else {
        cb(valid)
        return false
      }
    })
  }
}
